var _circle, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEkProposal3Outline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    role: "img",
    "aria-label": "Engin Kaya",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 42,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.55
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 70,
    textAnchor: "middle",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 36,
    fontWeight: 700,
    letterSpacing: 1,
    fill: "#ffffff"
  }, "ek")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkProposal3Outline);
export default __webpack_public_path__ + "static/media/ek-proposal-3-outline.be4cf618924dda0a8726b7a3aea41f10.svg";
export { ForwardRef as ReactComponent };